var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "execution" },
    [
      _c(
        "basic-container",
        [
          _c("avue-crud", {
            ref: "crud",
            attrs: {
              page: _vm.page,
              data: _vm.tableData,
              "table-loading": _vm.tableLoading,
              option: _vm.tableOption,
            },
            on: {
              "update:page": function ($event) {
                _vm.page = $event
              },
              "on-load": _vm.getList,
              "size-change": _vm.sizeChange,
              "current-change": _vm.currentChange,
              "refresh-change": _vm.refreshChange,
            },
            scopedSlots: _vm._u([
              {
                key: "menuBtn",
                fn: function (scope) {
                  return [
                    _vm.permissions.act_task_manage
                      ? _c(
                          "el-dropdown-item",
                          {
                            attrs: { divided: "" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.audit(scope.row, scope.index)
                              },
                            },
                          },
                          [_vm._v("审批\n        ")]
                        )
                      : _vm._e(),
                    _vm.permissions.act_task_manage
                      ? _c(
                          "el-dropdown-item",
                          {
                            attrs: { divided: "" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.comment(scope.row, scope.index)
                              },
                            },
                          },
                          [_vm._v("批注\n        ")]
                        )
                      : _vm._e(),
                    _vm.permissions.act_task_manage
                      ? _c(
                          "el-dropdown-item",
                          {
                            attrs: { divided: "" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.viewPic(scope.row, scope.index)
                              },
                            },
                          },
                          [_vm._v("流程图\n        ")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.showTask, title: "任务办理" },
          on: {
            "update:visible": function ($event) {
              _vm.showTask = $event
            },
          },
        },
        [
          _c("avue-form", {
            ref: "form",
            attrs: { option: _vm.formOption },
            scopedSlots: _vm._u([
              {
                key: "menuForm",
                fn: function (scope) {
                  return _vm._l(_vm.flagList, function (flag) {
                    return _c(
                      "el-button",
                      {
                        key: flag,
                        attrs: { icon: "el-icon-check", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.handleTask(scope.row, flag)
                          },
                        },
                      },
                      [_vm._v(_vm._s(flag) + "\n        ")]
                    )
                  })
                },
              },
            ]),
            model: {
              value: _vm.obj,
              callback: function ($$v) {
                _vm.obj = $$v
              },
              expression: "obj",
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.showComment, title: "批注列表" },
          on: {
            "update:visible": function ($event) {
              _vm.showComment = $event
            },
          },
        },
        [
          _c("avue-crud", {
            attrs: { data: _vm.taskTableData, option: _vm.taskOption },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.showPicDialog, title: "流程图" },
          on: {
            "update:visible": function ($event) {
              _vm.showPicDialog = $event
            },
          },
        },
        [
          _vm.showPicDialog
            ? _c("img", { attrs: { src: _vm.actPicUrl, width: "100%" } })
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }